import { Injectable } from '@angular/core';
import { SohoMessageService } from 'ids-enterprise-ng';
import { Observable } from 'rxjs';
import { LMDialogButtonKey } from '@utils/app.constants';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';

export enum ConfirmationDialogResult {
  CONFIRMATION_CANCEL = 0,
  CONFIRMATION_OK,
  CONFIRMATION_OKTOALL
}

export interface ConfirmationMessageOptions {
  message: string;
  title?: string;         // TODO DPB this is not used
  okToAll?: boolean;
  alertMessage?: string;
  dialogTitle?: string;
}

@Injectable()
export class LMConfirmationMessageService {
  constructor(
    private sohoMessageService: SohoMessageService,
    private lmUniqueIdService: LMUniqueIdService
  ) {}

  /**
   * Bring up the soho message service to display the confirmation message.
   * Args: message string, okToAll, title
   *
   */
  public promptConfirmationMessage(args: ConfirmationMessageOptions): Observable<ConfirmationDialogResult> {
    const msgConfirm: Observable<any> = new Observable(observer => {
      const dialogId = args.dialogTitle === undefined ? 'ConfirmationRequired' : args.dialogTitle;
      const okToAll = args.okToAll || false;
      const message = args.message;

      const buttons: SohoModalButton[] = [
        {
          id: this.lmUniqueIdService.uniqueId([dialogId, LMDialogButtonKey.CANCEL]),
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            modal.close(true);
            observer.next(ConfirmationDialogResult.CONFIRMATION_CANCEL);
          }
        },
        {
          id: this.lmUniqueIdService.uniqueId([dialogId, LMDialogButtonKey.OK]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          click: (e, modal) => {
            modal.close(true);
            observer.next(ConfirmationDialogResult.CONFIRMATION_OK);
          },
          isDefault: true
        }
      ];

      if (okToAll) {
        buttons.splice(1, 0, {
          id: this.lmUniqueIdService.uniqueId([dialogId, LMDialogButtonKey.OKTOALL]),
          text: Soho.Locale.translate(LMDialogButtonKey.OKTOALL),
          click: (e, modal) => {
            modal.close(true);
            observer.next(ConfirmationDialogResult.CONFIRMATION_OKTOALL);
          }
        });
      }

      // this.lmBusyIndicatorService.hideBusyIndicator();

      const attributes: SohoAttributesArray = [ { name:  'data-automation-id',  value: 'lm-ConfirmationRequired-modal' } ];
      const messageOptions: SohoMessageOptions = {
        allowedTags: '<div>, <span>, <p>',
        message,
        buttons,
        title: this.buildTitle(args),
        attributes
      };

      // Show the confirmation message dialog.
      this.sohoMessageService
        .message(messageOptions)
        .open();
    });
    return msgConfirm;
  }

  private buildTitle(options: ConfirmationMessageOptions): string {
    const title = options.title || Soho.Locale.translate('ConfirmationRequired');

    if (options.alertMessage) {
      return '<div>' + title + '</div><div class="notification alert lm-dialog-notification"><p>' + options.alertMessage + '</p></div>';
    } else {
      return title;
    }
  }
}
